import {createAction} from 'redux-act';

export const setTryOnVisibility = createAction<boolean>(
    'SET_TRY_ON_VISIBILITY',
    payload => payload,
);
